import { render } from "./SuhtlusAmetnikugaLeht.vue?vue&type=template&id=34951526&ts=true"
import script from "./SuhtlusAmetnikugaLeht.vue?vue&type=script&lang=ts"
export * from "./SuhtlusAmetnikugaLeht.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__